const Theme = {
    light: {
        colors:{
            primaryBackground: "#fff",
            secondaryBackground: "var(--black-10, #ECECEC)",
            primaryFontColor: "#333",
            secondaryFontColor: "#fff",
            buttonBackground: "var(--green-100, #3C9)",
            buttonBackgroundHover: "#7BD6B8",
            buttonBackgroundFocus: "#9DDBC6",
        },
        font: {
            family: "Segoe UI",
            display:{
                large: {
                    size: "96px",
                    line_height: "112px",
                    weight: "700",
                },
                medium:{
                    size: "52px",
                    line_height: "64px",
                    weight: "700",
                },
                small:{
                    size: "44px",
                    line_height: "52px",
                    weight: "700",
                },
            },
            headings:{
                large:{
                    size: "32px",
                    line_height: "40px",
                    weight: "700",
                },
                medium:{
                    size: "28px",
                    line_height: "36px",
                    weight: "700",
                },
                small:{
                    size: "24px",
                    line_height: "32px",
                    weight: "700",
                },
            },
            labels:{
                large:{
                    size: "20px",
                    line_height: "26px",
                    weight: "500",
                },
                medium:{
                    size: "18px",
                    line_height: "22px",
                    weight: "500",
                },
                small:{
                    size: "16px",
                    line_height: "18px",
                    weight: "500",
                },
            },
            paragraphs:{
                large:{
                    size: "18px",
                    line_height: "28px",
                    weight: "400",
                },
                medium:{
                    size: "16px",
                    line_height: "24px",
                    weight: "400",
                },
                small:{
                    size: "14px",
                    line_height: "20px",
                    weight: "400",
                },
            },
        }
    },

    dark:{
        colors:{
            secondaryBackground: "#0B1B3A",
            primaryBackground: "#233456",
            primaryFontColor: "#F2F2F2",
            secondaryFontColor: "#fff",
            buttonBackground: "#006560",
            buttonBackgroundHover: "#6E82AA",
            buttonBackgroundFocus: "#9BA8C3",
        },
        font: {
            family: "Segoe UI",
            display:{
                large: {
                    size: "96px",
                    line_height: "112px",
                    weight: "700",
                },
                medium:{
                    size: "52px",
                    line_height: "64px",
                    weight: "700",
                },
                small:{
                    size: "44px",
                    line_height: "52px",
                    weight: "700",
                },
            },
            headings:{
                large:{
                    size: "32px",
                    line_height: "40px",
                    weight: "700",
                },
                medium:{
                    size: "28px",
                    line_height: "36px",
                    weight: "700",
                },
                small:{
                    size: "24px",
                    line_height: "32px",
                    weight: "700",
                },
            },
            labels:{
                large:{
                    size: "20px",
                    line_height: "26px",
                    weight: "500",
                },
                medium:{
                    size: "18px",
                    line_height: "22px",
                    weight: "500",
                },
                small:{
                    size: "16px",
                    line_height: "18px",
                    weight: "500",
                },
            },
            paragraphs:{
                large:{
                    size: "18px",
                    line_height: "28px",
                    weight: "400",
                },
                medium:{
                    size: "16px",
                    line_height: "24px",
                    weight: "400",
                },
                small:{
                    size: "14px",
                    line_height: "20px",
                    weight: "400",
                },
            },
        },
    }
}

export default Theme;